import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductRequest, ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  products: ProductResponse[] = [];
  warehouseCategories: ProductResponse[] = [];
  editing = false;
  filterProducts = [];
  filterWord: string = "";
  filterFamily: string = "all";
  filterXML: string = "all";
  creating = false;
  waitingFor = new ProductRequest();
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  categories: { [key: number]: string } = {};
  changing: { [key: number]: boolean } = {};
  seeing: { [key: number]: boolean } = {};
  productIdEdited = null;

  favoriteProduct: ProductResponse = null;

  constructor(
    private toastService: ToastrService,
    private productService: ProductService
  ) {

  }

  ngOnInit(): void {
    this.getProducts();

  }
  exempt = 'n';
  createProduct() {
    this.exempt = 'n';
    this.waitingFor = new ProductRequest();
    this.creating = true;
  }

  getProducts() {
    this.productService.getProductList().subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data;
        this.productService.getCatalogs().subscribe({
          next: (response: ResponseObject) => {
            var productCategories = response.data.productCategories;
            productCategories.forEach(category => {
              this.categories[category.id] = category.name;
            });
            this.products.forEach((p) => {
              p['family'] = this.categories[p.parentCategory];
            })
            // this.pagination.total = this.products;
            // this.resetPagination();
            this.filter();
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        })
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  filter() {
    this.pagination.total = this.products.filter((p) => {

        const matchWord = (p.code + " - " + p.name)
            .toLowerCase()
            .includes(this.filterWord.toLowerCase());

        const hasFamily = p.parentCategory != null;

        let matchFamily = true;

        if (this.filterFamily === "with") {
            matchFamily = hasFamily;
        } else if (this.filterFamily === "without") {
            matchFamily = !hasFamily;
        }

        const hasXML = (p.code || "")
            .toUpperCase()
            .startsWith("XML");

        let matchXML = true;

        if (this.filterXML === "with") {
            matchXML = hasXML;
        } else if (this.filterXML === "without") {
            matchXML = !hasXML;
        }

        return matchWord && matchFamily && matchXML;
    });

    this.resetPagination();
  }

  edit(product: ProductResponse) {
    console.log(product);
    this.productIdEdited = product.id;
    this.waitingFor = new ProductRequest();
    this.waitingFor.barCode = product.barCode;
    this.waitingFor.bought = product.bought;
    this.waitingFor.category = product.category + "";
    this.waitingFor.code = product.code;
    this.waitingFor.description = product.description;
    this.waitingFor.exemptTextId = product.exemptTextId;
    this.waitingFor.extraTaxId = product.extraTaxId;
    this.waitingFor.hasExtraTax = product.hasExtraTax;
    this.waitingFor.idAssociated = product.idAssociated;
    this.waitingFor.image = product.image;
    this.waitingFor.isExempt = product.isExempt;
    this.waitingFor.measurement = product.measurement + "";
    this.waitingFor.name = product.name;
    this.waitingFor.parentCategory = product.parentCategory + "";
    this.waitingFor.productId = product.id;
    this.waitingFor.productType = product.productType;
    this.waitingFor.sold = product.sold;
    this.waitingFor.type = product.type;
    this.waitingFor.notAssociated = product.notAssociated;
    this.waitingFor.virtual = product.virtual;
    this.waitingFor.addcost = product.addcost;
    this.exempt = (product.isExempt) ? 'd' : 'n';
    this.creating = true;
  }

  closeCreate(created: boolean) {
    this.creating = false;
    this.productIdEdited = null;
    this.exempt = 'n';
    this.waitingFor = new ProductRequest();
    if (created) {
      this.getProducts();
    }
  }

  activeOrInactive(product: any) {
    if (this.changing[product.id]) {
      return;
    }
    this.changing[product.id] = true;
    this.productService.activeOrInactive(product.id).subscribe({
      next: (response: any) => {
        product.active = !product.active;
        this.toastService.success("Se ha " + ((product.active) ? 'activado' : 'desactivado') + " correctamente al producto");
        this.changing[product.id] = false;
      },
      error: (error: any) => {
        this.changing[product.id] = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  openFavorite(product: ProductResponse) {
    console.log("Favorito", product);
      this.favoriteProduct = product;
  }

  closeFavorite() {
    console.log("quitar favorito");
      this.favoriteProduct = null;
  }
}
